import React from "react";
import { CONTEXT_MANAGEMENT_READ_ONLY_MESSAGE, CONTEXT_MANAGEMENT_REACTIVATION_MESSAGE } from "@domain/valueObjects/contextManagementEntitlement";

const noticeStyle: React.CSSProperties = {
  margin: "8px 0 0",
  padding: "12px 16px",
  border: "1px solid #fde68a",
  borderRadius: 6,
  color: "#78350f",
  background: "#fffbeb",
};

export const EntitlementReadOnlyNotice: React.FC = () => (
  <div role="status" style={noticeStyle}>
    <strong>{CONTEXT_MANAGEMENT_READ_ONLY_MESSAGE}</strong>
    <div>{CONTEXT_MANAGEMENT_REACTIVATION_MESSAGE}</div>
  </div>
);
